<div class="annual-plan-dialog-form-phase">
  <form [formGroup]="attributePlanForm">
    <h1 mat-dialog-title>
      {{ data.dialogTitle | translate}}
    </h1>
    <div mat-dialog-content>
      <fieldset [disabled]="isSubmitting" id="fieldset-list">
        <div class="line line-margin">
          <div fxLayout="column" fxLayoutAlign="start">
            <div>
              <h5>{{ 'ExportRange' | translate }}</h5>
            </div>
            <div fxLayout="row" fxLayoutAlign="start">
              <div fxFlex="50">
                <mat-form-field>
                  <mat-select placeholder="{{ 'StartedAt' | translate }}" [compareWith]="compareWeekMenus" formControlName="exportFrom">
                    <mat-option *ngFor="let menuFrom of weekNumbers" [value]="menuFrom">
                      {{ menuFrom.realNumber ? menuFrom.realNumber + ' (' + menuFrom.realWeekYear + ')' : menuFrom.number }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f['exportFrom'].errors && f['exportFrom'].hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                  <mat-error *ngIf="f['exportFrom'].errors && f['exportFrom'].hasError('lessThanNumber')">{{ 'Field_less_than_end' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field>
                  <mat-select placeholder="{{ 'EndedAt' | translate }}" [compareWith]="compareWeekMenus" formControlName="exportTo">
                    <mat-option *ngFor="let menuTo of weekNumbers" [value]="menuTo">
                      {{ menuTo.realNumber ? menuTo.realNumber + ' (' + menuTo.realWeekYear + ')' : menuTo.number }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f['exportTo'].errors && f['exportTo'].hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                  <mat-error *ngIf="f['exportTo'].errors && f['exportTo'].hasError('greaterThanNumber')">{{ 'Field_more_than_start' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="line line-margin">
          <mat-form-field [hintLabel]="'date_format_hint' | translate">
            <mat-label class="required">{{ 'ImportFrom' | translate }}</mat-label>
            <input matInput formControlName="importStartDate" [matDatepicker]="importStartDate" autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="importStartDate"></mat-datepicker-toggle>
            <mat-datepicker #importStartDate startView="year" [startAt]="startDate"></mat-datepicker>
            <mat-error *ngIf="f['importStartDate'].errors && f['importStartDate'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
          </mat-form-field>
        </div>
        <div class="line line-margin teams-block">
          <div fxLayout="column" fxLayoutAlign="start">
            <div>
              <h5>{{ 'Teams' | translate }}</h5>
            </div>
            <div fxLayout="row" fxLayoutAlign="start">
              <div fxFlex="100">

                <!-- Champ de recherche -->
                <div>
                  <mat-form-field class="search-field">
                    <mat-label>{{ 'Search' | translate }}</mat-label>
                    <input matInput #inputValue (input)="filterAthletes($event)">
                  </mat-form-field>
                </div>
                <center-loader *ngIf="dataSource.data.length === 0 && !(inputValue.value.length > 0)"></center-loader>
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                      <button mat-icon-button disabled></button>
                      <mat-checkbox class="checklist-leaf-node"
                                    [checked]="checklistSelection.isSelected(node)"
                                    (change)="todoLeafItemSelectionToggle(node, $event)">{{node.item}}</mat-checkbox>
                    </mat-tree-node>

                  <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
                    <button mat-icon-button disabled></button>
                  </mat-tree-node>

                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                      <button mat-icon-button matTreeNodeToggle
                              [attr.aria-label]="'toggle ' + node.filename">
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                      </button>
                      <mat-checkbox [checked]="descendantsAllSelected(node)"
                                    [indeterminate]="descendantsPartiallySelected(node)"
                                    (change)="todoItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
                    </mat-tree-node>
                  </mat-tree>

                <mat-error *ngIf="!this.checklistValidated">{{ 'Field_required' | translate }}</mat-error>
              </div>
            </div>
          </div>
          <!--
                              <div class="filter-panel">
                                  <ul>
                                      <li>
                                          <div *ngFor="let data of teamsAthletes; let i = index;" class="section">
                                              <div class="group-checkbox">
                                                  <mat-checkbox
                                                          color="primary"
                                                          class="sub-checkbox"
                                                          (change)="onChange($event)">
                                                      <div class="label">{{ data.team.name }}</div>
                                                  </mat-checkbox>
                                              </div>

                                              <ul>
                                                  <li *ngFor="let user of data.athletes; let i = index" >
                                                      <mat-checkbox
                                                              color="primary"
                                                              class="sub-checkbox"
                                                              [value]="user"
                                                              (change)="onChange($event)">
                                                          <div class="label">{{ user.firstName }} {{ user.lastName }}</div>
                                                      </mat-checkbox>
                                                  </li>
                                              </ul>
                                          </div>
                                      </li>
                                  </ul>
                              </div>
                              -->
        </div>
      </fieldset>
    </div>
    <mat-dialog-actions>

      <button mat-button mat-dialog-close tabindex="-1">
        {{ 'Cancel' | translate}}
      </button>

      <button mat-raised-button (click)="submitForm()" color="accent">
        {{ 'Attribute' | translate}}
      </button>

    </mat-dialog-actions>
  </form>
</div>
